import _get from 'lodash/get';
import _isString from 'lodash/isString';
import { isScrollParentRefValid } from '.';
export var computeGetPopupContainerProp = function computeGetPopupContainerProp(_ref) {
  var scrollParentRef = _ref.scrollParentRef,
    scrollParentSelector = _ref.scrollParentSelector;
  if (_isString(scrollParentSelector) && scrollParentSelector !== '') {
    var getScrollContainer = function getScrollContainer() {
      var scrollParentNode = document.querySelector(scrollParentSelector);
      return scrollParentNode || document.body;
    };
    return {
      getPopupContainer: getScrollContainer,
      getCalendarContainer: getScrollContainer
    };
  }
  return isScrollParentRefValid(scrollParentRef) ? {
    getPopupContainer: function getPopupContainer() {
      return _get(scrollParentRef, 'current');
    }
  } : null;
};